

$(document).on('click', '.customSlideBanner .arrow', function() {
    var isMobile = $('body').hasClass('mobile'); // Zjistí, jestli má body třídu .mobile
    var smallWidth = isMobile ? '56px' : '90px'; // Šířka pro zavřené zobrazení
    var largeWidth = '90%'; // Šířka pro otevřené zobrazení

    $(this).closest('.customSlideBanner').toggleClass('closeIt');
    $(this).closest('.customSlideBanner').find('.right').slideToggle(0);

    if ($(this).closest('.customSlideBanner').css('width') === smallWidth) {
        $(this).closest('.customSlideBanner').animate({
            width: largeWidth
        }, 10);
        sessionStorage.setItem('infoMsgState', 'openInfoMessage');
    } else {
        $(this).closest('.customSlideBanner').animate({
            width: smallWidth
        }, 500);
        sessionStorage.setItem('infoMsgState', 'hideInfoMessage');
    }
});

$(document).ready(function() {
    var isMobile = $('body').hasClass('mobile'); // Zjistí, jestli má body třídu .mobile
    var smallWidth = isMobile ? '56px' : '90px'; // Šířka pro zavřené zobrazení

    if (sessionStorage.getItem('infoMsgState') === 'hideInfoMessage') {
        $('.customSlideBanner').addClass('closeIt'); // Nastaví třídu pro zavřené zobrazení
        $('.customSlideBanner').find('.right').slideToggle(0);
        $('.customSlideBanner').animate({
            width: smallWidth
        }, 0);
    }
});